import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Login from "./pages/Login";
import TemplateBase from "./components/TemplateBase";
import TemplateCliente from "./components/TemplateCliente";
import CadastroCliente from "./pages/CadastroCliente";
import ListagemClientes from "./pages/ListagemClientes";
import CadastroUsuario from "./pages/CadastroUsuario";
import CadastroCoordenador from "./pages/CadastroCoordenador";
import EdicaoCliente from "./pages/EdicaoCliente";
import DetalhesCliente from "./pages/DetalhesCliente";
import TheSimonProject from "./pages/TheSimonProject";
import DashHome from "./pages/DashHome";
import SetupCliente from "./pages/SetupCliente";
import CadastroDisciplina from "./pages/CadastroDisciplina";
import ListagemDisciplinas from "./pages/ListagemDisciplinas";
import DetalhesDisciplina from "./pages/DetalhesDisciplina";
import EditarDisciplina from "./pages/EditarDisciplina";
import CadastroCurso from "./pages/CadastroCurso";
import ListagemCursos from "./pages/ListagemCursos";
import DetalhesCurso from "./pages/DetalhesCurso";
import EditarCurso from "./pages/EditarCurso";
import ListagemCoordenadores from "./pages/ListagemCoordenadores";
import DetalhesCoordenador from "./pages/DetalhesCoordenador";
import EditarCoordenador from "./pages/EditarCoordenador";
import CadastroTurma from "./pages/CadastroTurma"; 
import ListagemTurmas from "./pages/ListagemTurmas";
import DetalhesTurma from "./pages/DetalhesTurma";
import EditarTurma from "./pages/EditarTurma";
import CadastroProfessor from "./pages/CadastroProfessor";
import ListagemProfessores from "./pages/ListagemProfessores";
import DetalhesProfessor from "./pages/DetalhesProfessor";
import EditarProfessor from "./pages/EditarProfessor";
import ListagemLogs from "./pages/ListagemLogs";
import MeusDados from "./pages/MeusDados";
import CadastroSessaoAula from "./pages/CadastroSessaoAula";
import ListagemSessoesAula from "./pages/ListagemSessoesAula";
import DetalhesSessaoAula from "./pages/DetalhesSessaoAula";
import EditarSessaoAula from "./pages/EditarSessaoAula";
import DetalhesTurmaCheckpoint from "./pages/DetalhesTurmaCheckpoint";
import CadastroCheckpointModelo from "./pages/CadastroCheckpointModelo";
import ListarCheckpointModelos from "./pages/ListarCheckpointModelos";
import AutorizarCheckpointModelo from "./pages/AutorizarCheckpointModelo";
import PublicarCheckpoint2 from "./pages/PublicarCheckpoint2";
import ListagemCheckpoints from "./pages/ListagemCheckpoints";
import ResponderCheckpoint from "./pages/ResponderCheckpoint";


function App() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/";
  const isPublicResponder = location.pathname.startsWith("/responder/");
  const tipoUsuario = localStorage.getItem("tipo");

  if (isLoginPage) {
    return (
      <Routes>
        <Route path="/" element={<Login />} />
      </Routes>
    );
  }

  if (isPublicResponder) {
    return (
      <Routes>
        <Route path="/responder/:id" element={<ResponderCheckpoint />} />
      </Routes>
    );
  }

  // 🔹 Usuário MASTER
  if (tipoUsuario === "master") {
    return (
      <TemplateBase>
        <Routes>
          <Route path="/cadastro-cliente" element={<CadastroCliente />} />
          <Route path="/clientes" element={<ListagemClientes />} />
          <Route path="/cadastro-usuario/:clienteId" element={<CadastroUsuario />} />
          <Route path="/editar-cliente/:id" element={<EdicaoCliente />} />
          <Route path="/cliente/:id" element={<DetalhesCliente />} />
          <Route path="/the-simon-project" element={<TheSimonProject />} />
          <Route path="/dashhome" element={<DashHome />} />
          <Route path="/setup-cliente/:id" element={<SetupCliente />} />
          <Route path="/logs" element={<ListagemLogs />} />
          <Route path="/meus-dados" element={<MeusDados />} />
          <Route path="/cadastro-checkpoint-modelo" element={<CadastroCheckpointModelo />} />
          <Route path="/modelos-checkpoints" element={<ListarCheckpointModelos />} />
          <Route path="/usuario/checkpoints" element={<ListagemCheckpoints />} />
        </Routes>
      </TemplateBase>
    );
  }

  return (
    <TemplateCliente>
      <Routes>
        <Route path="/coordenadores/cadastro/:clienteId" element={<CadastroCoordenador />} />
        <Route path="/cadastro-disciplina" element={<CadastroDisciplina />} />
        <Route path="/disciplinas" element={<ListagemDisciplinas />} /> 
        <Route path="/disciplina/:id" element={<DetalhesDisciplina />} />
        <Route path="/editar-disciplina/:id" element={<EditarDisciplina />} />
        <Route path="/cursos/cadastrar" element={<CadastroCurso />} />
        <Route path="/cursos" element={<ListagemCursos />} />
        <Route path="/detalhes-curso/:id" element={<DetalhesCurso />} />
        <Route path="/editar-curso/:id" element={<EditarCurso />} />
        <Route path="/coordenadores" element={<ListagemCoordenadores />} />
        <Route path="/coordenadores/:id" element={<DetalhesCoordenador />} />
        <Route path="/coordenadores/editar/:id" element={<EditarCoordenador />} />
        <Route path="/cadastro-turma" element={<CadastroTurma />} />
        <Route path="/turmas" element={<ListagemTurmas />} />
        <Route path="/editar-turma/:id" element={<EditarTurma />} />
        <Route path="/professores" element={<ListagemProfessores />} />
        <Route path="/professores/cadastro/:clienteId" element={<CadastroProfessor />} />
        <Route path="/professores/:id" element={<DetalhesProfessor />} />
        <Route path="/detalhes-turma/:id" element={<DetalhesTurma />} />
        <Route path="/professores/editar/:id" element={<EditarProfessor />} />
        <Route path="/meus-dados" element={<MeusDados />} />
        <Route path="/minhas-disciplinas" element={<ListagemDisciplinas />} />
        <Route path="/minhas-sessoes" element={<ListagemSessoesAula />} />
        <Route path="/cadastro-sessao" element={<CadastroSessaoAula />} />
        <Route path="/sessao/:id" element={<DetalhesSessaoAula />} />
        <Route path="/editar-sessao/:id" element={<EditarSessaoAula />} />
        <Route path="/checkpoints/turma/:id" element={<DetalhesTurmaCheckpoint />} />
        <Route path="/autorizar-checkpoints" element={<AutorizarCheckpointModelo />} />
        <Route path="/publicar-checkpoint2/:disciplina_id/:turma_id" element={<PublicarCheckpoint2 />} />
        <Route path="/checkpoints" element={<ListagemCheckpoints />} />
        <Route path="/usuario/checkpoints" element={<ListagemCheckpoints />} />
      </Routes>
    </TemplateCliente>
  );
}

export default App;
